import Styles from "./index.module.scss";
import { ReactComponent as WarningIcon } from '../../../../assets/icons/error-warning.svg';

const ErrorBar = ({ message }) => {
    return (
        <div className={Styles.errorContainer}>
            <WarningIcon className={Styles.icon} />
            <span className={Styles.message}>{message}</span>
        </div>
    );
};

export default ErrorBar;